import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HelpersService } from "@shared/helpers/helpers.service";
import { Subscription } from "rxjs";
import { IABCMoneda } from "../interfaces/IGetABCMonedas";
import { AbcMonedasService } from "../services/abc-monedas.service";
import { LoadingComponent } from "@app/theme/loading/loading.component";
import { SwalService } from "@shared/utils/swal.service";
import { MatDialog } from "@angular/material/dialog";
import { AbcEmpresasCustomizablesComponent } from "@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-customizables/abc-empresas-customizables.component";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AbcMonedasParidadesComponent } from "../abc-monedas-paridades/abc-monedas-paridades.component";

@Component({
    selector: "app-abc-monedas-form",
    templateUrl: "./abc-monedas-form.component.html",
    styleUrl: "./abc-monedas-form.component.css",
    providers: [DialogService, DynamicDialogConfig, DynamicDialogRef],
})
export class AbcMonedasFormComponent implements OnInit, OnChanges {
    form: FormGroup;
    @Input() openModal!: EventEmitter<void>;
    @Input() dataModal: IABCMoneda = {} as IABCMoneda;
    @Output() closeModal = new EventEmitter<void>();
    private subscription!: Subscription;
    visible: boolean = false;
    monedaForm: FormGroup;
    isEdit: boolean = false;
    constructor(
        private fb: FormBuilder,
        private loading: LoadingComponent,
        public _helpers: HelpersService,
        private monedasService: AbcMonedasService,
        private _swalService: SwalService,
        private dialog: MatDialog
    ) {
        this.reset();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["dataModal"] && changes["dataModal"].currentValue) {
            if (this.dataModal.moneda) {
                this.monedaForm.controls["moneda"].setValue(this.dataModal.moneda);
                this.monedaForm.controls["descripcion"].setValue(this.dataModal.descripcion);
                this.monedaForm.controls["factor"].setValue(this.dataModal.factor);
                this.monedaForm.controls["fecha"].setValue(this._helpers.DateNowInputString());
                const user = sessionStorage.getItem("user");
                this.monedaForm.controls["responsable"].setValue(user ? JSON.parse(user) : "");
                this.monedaForm.controls["fecha"].disable();
                this.monedaForm.controls["responsable"].disable();
                this.monedaForm.controls["moneda"].disable();
                this.isEdit = true;
            } else {
                this.reset();
            }
        }
    }

    ngOnInit(): void {
        this.subscription = this.openModal.subscribe(() => {
            this.visible = true;
        });
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    save() {
        this.loading.openDialogLoading(true);
        this.monedaForm.controls["moneda"].enable();
        this.monedaForm.controls["responsable"].enable();
        this.monedaForm.controls["fecha"].enable();

        const payload: IABCMoneda = {
            moneda: this.monedaForm.controls["moneda"].value,
            descripcion: this.monedaForm.controls["descripcion"].value,
            factor: this.monedaForm.controls["factor"].value,
            fecha_Ultima: this._helpers.getTodayInJulianas(),
            responsable: this.monedaForm.controls["responsable"].value,
        };

        if (this.isEdit) {
            this.monedasService.EditABCMoneda(payload).subscribe({
                next: (res) => {
                    this._swalService.success("Moneda editada exitosamente");
                    this.loading.openDialogLoading(false);
                    this.visible = false;
                    this.closeModal.emit();
                    this.reset();
                },
                error: (err) => {
                    this.loading.openDialogLoading(false);
                    console.log(err);
                    this.reset();
                },
            });
            return;
        } else {
            this.monedasService.CreateABCMoneda(payload).subscribe({
                next: (res) => {
                    this._swalService.success("Moneda creada exitosamente");
                    this.loading.openDialogLoading(false);
                    this.visible = false;
                    this.closeModal.emit();
                    this.reset();
                },
                error: (err) => {
                    this.loading.openDialogLoading(false);
                    console.log(err);
                    this._swalService.error(
                        "No se pudo guardar la moneda. Verifica los datos ingresados y asegúrate de que la moneda no esté registrada previamente. Si el problema persiste, por favor contacta al administrador."
                    );
                    this.monedaForm.controls["responsable"].disable();
                    this.monedaForm.controls["fecha"].disable();
                },
            });
        }
    }

    reset() {
        this.monedaForm = this.fb.group({
            moneda: [null, Validators.required],
            descripcion: ["", Validators.required],
            factor: [0, Validators.required],
            fecha: ["", Validators.required],
            responsable: ["", Validators.required],
        });

        this.monedaForm.controls["fecha"].setValue(this._helpers.DateNowInputString());
        const user = sessionStorage.getItem("user");
        this.monedaForm.controls["responsable"].setValue(user ? JSON.parse(user) : "");
        this.monedaForm.controls["fecha"].disable();
        this.monedaForm.controls["responsable"].disable();
        this.isEdit = false;
    }

    customizables(): void {
        const dialogRef = this.dialog.open(AbcEmpresasCustomizablesComponent, {
            width: "1000px",
            height: "1000px",
            disableClose: true,
            panelClass: ["custom-dialog-zindex"],
            hasBackdrop: true,
            autoFocus: false,
            data: {
                sTabla: "Monedas",
                sClave: `${this.dataModal.moneda}`,
                sNombre: this.dataModal.descripcion,
                sTipo: "Opcion",
            },
        });
    }

    paridades(): void {
        const dialogRef = this.dialog.open(AbcMonedasParidadesComponent, {
            width: "1000px",
            height: "1000px",
            disableClose: true,
            panelClass: ["custom-dialog-zindex"],
            hasBackdrop: true,
            autoFocus: false,
            data: {
                moneda: this.dataModal.moneda,
            },
        });
    }
}
